/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 21:39:43 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-04-25 13:44:03
 */

import {moduleName} from "./constants"

export const getMessage = (state) => (state[moduleName])